// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/CardCaption/card-caption.sass
// module id = 354
// module chunks = 0